<button
  [type]="htmlButtonType()"
  [ngClass]="[
    variantClass(),
    sizeClass(),
    linkClass(),
    loadingClass(),
    disabledClass(),
    onlyIconClass(),
    darkModeClass()
  ]"
  [disabled]="disabled() || loading()"
  (click)="onClick.emit()"
  [attr.aria-label]="label() || icon() || trailingIcon()">
  @if (icon()) {
    <ui-icon [icon]="icon()!" [size]="iconSize()" />
  }
  @if (label()) {
    {{ loading() ? loadingLabel() : label() }}
  }
  @if (trailingIcon()) {
    <ui-icon [icon]="trailingIcon()!" [size]="iconSize()" />
  }
</button>
